<template>
	<div class="animated fadeIn">
		<div class="container">
			<user-data-form
				:form-import="form"
				:create-new-user="true"
				:errors-import="errors.errors"
				:statuses="statuses"
				:processing="processing"
				@requestData="requestNewUser" />
		</div>
	</div>
</template>
<script>

import User from '@/util/User';
import { STATUSES as statuses } from '@/settings/Statuses';
import { Validations as messages } from '@/translations';
import UserDataForm from '@/views/Users/components/UserDataForm';

export default {
	name: 'New3PLUser',
	messages,
	components: {
		UserDataForm,
	},
	data() {
		return {
			users: new User(),
			statuses,
			form: {
				username: '',
				email: '',
				first_name: '',
				last_name: '',
				status: 'active',
				type: '3pl',
				mobile_number: '',
				password: '',
				password_confirmation: '',
			},
			alert: new this.$Alert(),
			processing: false,
		};
	},
	computed: {
		errors() {
			return this.users.data.errors;
		},
	},
	methods: {
		requestNewUser(payload) {
			this.processing = true;
			this.users.create3pl(payload).then(() => {
				try {
					this.alert.toast('success', this.translate('user_created'));
				} finally {
					this.$router.push({ name: '3PLUsers' });
				}
			})
				.catch(() => { this.data = payload; })
				.finally(() => {
					this.processing = false;
				});
		},
	},
};
</script>
